export default __webpack_public_path__ + "static/martha-geilman-2-3fa94c5d6e4ac3229f1ef0f985f817bf.png";